import Column from '@components/column'
import Row from '@components/row'
import CardHeading from '@commons/headings/card'
import { styleRow } from './style'
import Empty from '@commons/empty'
import Typography from '@components/typography'
import { format, parse } from 'date-fns'
const Availabilities = ({ institution }) => {
  const parseTime = (time: string) => parse(time, 'HH:mm', new Date())
  return (
    <Column styleColumn="border-radius:8px;padding:20px;" bg="white">
      <Column styleColumn="margin-bottom:30px;">
        <CardHeading title="Available Hours" />
      </Column>

      {!!institution?.availabilities?.length ? (
        <Column styleColumn={styleRow} rowGap={20}>
          {institution?.availabilities?.map((availability: any) => {
            return (
              <Row
                key={availability?.id}
                justifyContent="space-between"
                alignItems="center"
              >
                <Column>
                  <Typography content={availability?.day} size={12} tc="text" />
                </Column>
                <Row>
                  {!!availability?.slots.isClosed ? (
                    <Typography
                      content={`Remains Closed`}
                      size={12}
                      tc="danger"
                    />
                  ) : !!availability?.slots?.isOpenAllDay ? (
                    <Typography
                      content={`Open All Day`}
                      size={12}
                      tc="secondary"
                    />
                  ) : (
                    <Typography
                      content={`${format(parseTime(availability?.slots?.startTime), 'hh:mm aa')} - ${format(parseTime(availability?.slots?.endTime), 'hh:mm aa')}`}
                      size={12}
                      tc="text"
                    />
                  )}
                </Row>
              </Row>
            )
          })}
        </Column>
      ) : (
        <Empty />
      )}
    </Column>
  )
}

export default Availabilities
